<template>
<div id="deposit-03">
    <div class="container pr-4 pl-4 pt-5">
        <div class="row">
            <div class="col number-bullet-lg-width-flex">
                <div class="number-bullet-lg rounded-circle d-flex align-items-center justify-content-center bg-primary-dimmed">
                    <p class="h4 font-weight-normal m-0 text-primary">2</p>
                </div>
            </div>
            <div class="col pl-0 d-flex align-items-center">
                <p class="h3 font-weight-normal m-0">ยอดเงินที่ต้องโอน</p>
            </div>
        </div>
        <div class="row pt-4">
            <div class="col">
                <div class="card shadow">
                    <div class="card-body">
                        <div v-if="isPreProcessing" class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <p class="h1 text-center m-0">{{request.decimalAmount}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-4">
            <div class="col number-bullet-xl-width-flex">
                <div class="number-bullet-xl rounded-circle d-flex align-items-center justify-content-center bg-danger-dimmed">
                    <p class="h3 font-weight-normal m-0 text-danger">!</p>
                </div>
            </div>
            <div class="col pl-0 d-flex align-items-center">
                <p class="text-danger m-0">โปรดโอนเงินตามยอดทศนิยมระบบจะตรวจสอบยอดของท่านจากเศษทศนิยมเท่านั้น</p>
            </div>
        </div>
        <!-- <div class="row pt-4">
            <div class="col pl-0 d-flex align-items-center">
                <p class="text-danger m-0" style="display:block;height:20px;"></p>
            </div>
        </div> -->
    </div>
    <hr class="my-4">
    <div class="px-4">
        <p class="h6 mb-3">ท่านจะต้องปฏิบัติดังต่อไปนี้ ในหน้าถัดไป<br><small style="opacity: 0.6;">(กรุณากดติ๊กถูกที่ช่อง เพื่อยืนยันว่าอ่านแล้ว)</small></p>
        <div class="form-check mb-3">
            <input v-model="checkCond[0]" type="checkbox" class="form-check-input" style="width: 24px; height: 24px;" id="check-cond-0">
            <label class="form-check-label h6 pl-3 font-weight-normal text-dark" for="check-cond-0"><span class="text-danger">สำคัญ</span> ฉันจะโอนเงินจากบัญชีที่ฉันลงทะเบียนไว้กับ Goobank เท่านั้นและไม่โอนผ่านตู้เงินสด, ร้านค้า, Airpay, บุญเติม, หรือช่องทางเงินสดอื่นๆ โดยเด็ดขาด</label>
        </div>
        <div class="form-check mb-3">
            <input v-model="checkCond[1]" type="checkbox" class="form-check-input" style="width: 24px; height: 24px;" id="check-cond-1">
            <label class="form-check-label h6 pl-3 font-weight-normal text-dark" for="check-cond-1">ฉันจะโอนเงินข้างต้นโดยมีทศนิยมที่กำหนดไว้ข้างต้น</label>
        </div>
        <div class="form-check">
            <input v-model="checkCond[2]" type="checkbox" class="form-check-input" style="width: 24px; height: 24px;" id="check-cond-2">
            <label class="form-check-label h6 pl-3 font-weight-normal text-dark" for="check-cond-2">ฉันจะอัพโหลดรูปสลิปยืนยันการโอนเงินหลังจากโอนเงินเสร็จ</label>
        </div>
    </div>
    <div class="px-4 pb-4 pt-2">
        <button @click="confirmDepositRequest()" :disabled="!checkCond[0] || !checkCond[1] || !checkCond[2] || (isPreProcessing || isProcessing)" class="btn btn-primary btn-lg btn-block">
            <template v-if="checkCond[0] && checkCond[1] && checkCond[2]">
                ไปหน้าถัดไป
            </template>
            <template v-else>
                กรุณายืนยันว่าอ่านแล้ว
            </template>
        </button>
        <button @click="cancelDepositRequest()" :disabled="isPreProcessing || isProcessing" class="btn btn-light btn-lg btn-block">
            ย้อนกลับ
        </button>
    </div>
</div>
</template>

<script>
export default {
    data: () => ({
        isPreProcessing: true,
        isProcessing: false,
        checkCond: [false, false, false],
        request: {
            id: '',
            decimalAmount: '',
            expire: ''
        }
    }),
    async created () {
        try {
            const result = await this.$api.deposit.getUserCurrentStep()
            const data = result.data
            if (data.step !== 'WAIT_USER_CONFIRM') this.$router.replace({ name: 'deposit-01' })
            this.request = result.data.request
            this.isPreProcessing = false
        } catch (error) {
            console.error(error)
        }
    },
    methods: {
        async confirmDepositRequest () {
            this.isProcessing = true
            try {
                const result = await this.$api.deposit.confirm(this.request.requestId)
                const data = result.data
                if (data.success) {
                    this.$router.replace({ name: 'deposit-04' })
                }
            } catch (error) {
                console.error(error)
            }
        },
        async cancelDepositRequest () {
            this.isProcessing = true
            try {
                await this.$api.deposit.cancel(this.request.requestId)
                this.$router.replace({ name: 'deposit-02' })
            } catch (error) {
                console.error(error)
            }
        }
    }
}
</script>

<style>
</style>
